import React from 'react';
import { ListGroup } from 'react-bootstrap';

const Sidebar = ({ workflows, selectedWorkflow, onSelectWorkflow }) => {
  return (
    <div className="sidebar">
      <h4 className="mb-1 px-2 pt-2" style={{fontSize: '1.1rem'}}>Workflows</h4>
      <ListGroup variant="flush">
        {workflows.map((workflow) => (
          <ListGroup.Item
            key={workflow.id}
            action
            active={selectedWorkflow?.id === workflow.id}
            onClick={() => onSelectWorkflow(workflow)}
            className="workflow-item"
          >
            <div className="d-flex justify-content-between align-items-center">
              <span>{workflow.name}</span>
              <span className="badge bg-secondary rounded-pill">
                {workflow.detected.length}
              </span>
            </div>
          </ListGroup.Item>
        ))}
      </ListGroup>
    </div>
  );
};

export default Sidebar;

